'use strict'
import RouteMarker from '../markers/route-marker.js';
import PhotoMarker from '../markers/photo-marker.js';
import L from 'leaflet';
import { getConfig } from '../../config';

export default class Route {
    constructor(routeInfo, map, colorIndex, hideIcons, playbackIcon, disableRouteMarkers, fullRouteInfo) {
        this.type = 'default';
        this.route = routeInfo;
        this.routeLayer = new L.featureGroup();
        this.markersLayer = null;
        this.allDistance = 0;
        this.coordsArray = [];
        this.config = getConfig();
        this.playBackCoordsArray = [];
        this.playBackTimesArray = [];
        this.playbackIcon = playbackIcon;

        this.fullRouteInfo = fullRouteInfo;

        this.routesColors = ['green', 'blue', 'red', 'purple', 'plum', 'black', 'yellow', 'grey', 'coral', 'lightgreen'];
        this.alarmColors = ['red', 'orange', 'grey', 'blue', 'green'];
        this.speedColors = ['green', 'lightgreen', 'yellow', 'red'];

        // defaultServerSettingsForNewInterfaceRoutesColors - глобальная настройка из settings.js
        if (typeof (defaultServerSettingsForNewInterfaceRoutesColors) != 'undefined' && defaultServerSettingsForNewInterfaceRoutesColors.length > 0) {
            this.routesColors = defaultServerSettingsForNewInterfaceRoutesColors;
        }

        // Настройки для ColorRoute
        this.colorOptions = [];
        this.colorMap = new Map();
        this.colorMapLastIndex = 0;
        //

        this.map = map;
        this.PhotosWindow = null;
        this.speedThresholds = [40, 60, 90];
        this.color = this._getRouteColor(colorIndex);
        this.markersLayer = new L.featureGroup.collision({ margin: 5 });

        this.pointsMakers = [];
        this.startEndMarkersLayer = new L.featureGroup({ clusterPane: 'startEndRoutePane' });

        this.arrayOfPhotos = [];
        this.photosLayer = new L.featureGroup.collision({ margin: 5 });

        this.playback = null;

        for (let point of this.route.coords) {
            this._makeFullRouteDistance(point);
            this._fillCoordsArray(point);
            this._fillPlayBackArrays(point);
            if (!hideIcons) {
                let marker = this._createRouteMarker(point);
                this.markersLayer.addLayer(marker);
                this.pointsMakers.push(marker);
            }
        }

        this._addLayer();

        var showMarkersLayer = true;

        if (disableRouteMarkers == true)
            showMarkersLayer = false;

        if (showMarkersLayer)
            this._addMarkersLayer();

        this.makeFitBoundsEvent();
        if (!hideIcons) {
            this._finalizeRoute();
        }

        if (this.map.options.initPhotosWindow) {
            this.initPhotosWindow(this.arrayOfPhotos);
        }

        this._makePhotosLayer(this.route.photos, this.route.oid, this.PhotosWindow);
        this._makeAddLayerEvent(this.photosLayer);

        if (this.map.options.initPlayback) {
            this._initPlayback();
        }
    }

    _fillPlayBackArrays(point) {
        if (point.tm) {
            this.playBackCoordsArray.push([point.lon, point.lat]);
            this.playBackTimesArray.push(fmtools.getLocalDateTime(point.tm).getTime() / 1000);
        }
    }

    _createRouteMarker(point) {
        return new RouteMarker(this.map, point, this.route.oid, this.allDistance, this.color);
    }

    _addMarkersLayer() {
        this._makeAddLayerEvent(this.markersLayer);
    }

    _addLayer() {
        if (this.coordsArray.length > 1) {
            let polyline = this._createLayer();
            this.routeLayer.addLayer(polyline);
            this._makeAddLayerEvent(this.routeLayer);
        }
    }

    _makePhotosLayer(photos, oid) {
        if (!photos) photos = [];
        for (let [index, photo] of photos.entries()) {
            let photoMarker = new PhotoMarker(photo, oid, index, this.PhotosWindow, this.map);
            this.arrayOfPhotos.push(photoMarker);
            this.photosLayer.addLayer(photoMarker);
        }
    }

    _initPlayback() {
        let stops = [];
        if (this.fullRouteInfo.stops.stops) {
            for (let stop of this.fullRouteInfo.stops.stops) {
                const start = fmtools.getLocalDateTime(stop.stop_time).getTime() / 1000;
                stops.push({
                    start,
                    end: start + stop.duration,
                    duration: stop.duration,
                });
            }
        }
        let geoJSON = {
            type: 'Feature',
            geometry: {
                type: 'MultiPoint',
                coordinates: this.playBackCoordsArray
            },
            properties: {
                time: this.playBackTimesArray,
                allTrack: this.route.coords,
                stops,
            },
            bbox: []
        };

        let playbackIcon = {
            iconUrl: '../../../Scripts/fort-map/dist/images/playback-marker.png',
            iconAnchor: [12, 12],
            iconSize: [24, 24]
        };

        if (!!this.playbackIcon) {
            playbackIcon = {
                iconUrl: this.playbackIcon.iconUrl,
                iconAnchor: [...this.playbackIcon.iconAnchor],
                iconSize: [...this.playbackIcon.iconSize]
            }
        }
        this.playback = new L.Playback(this.map, geoJSON, /*onPlaybackTimeChange*/null, {
            tickLen: 1000,
            tracksLayer: false,
            playControl: false,
            dateControl: false,
            sliderControl: false,
            marker: function () {
                return {
                    icon: L.icon({...playbackIcon}),
                    pane: 'startEndRoutePane',
                };
            }
        }, null /*track*/);
    }

    _recalcCollisionMarkers() {
        var bounds = this.map.getBounds();
        var map_cells = [];
        var zoom = this.map.getZoom();
        // перебираем все маркеры на слое.
        this.markersLayer.eachLayer((marker) => {
            var pnt1 = this.map.latLngToContainerPoint(marker.getLatLng());
            var cell = this._getCellCoord(pnt1, zoom);
            // теперь проверяем, что в этой ячейке сетки еще нет добавленной иконки точки трека
            if (map_cells[cell] === undefined || map_cells[cell] != true) {
                marker.setOpacity(1);
                map_cells[cell] = true;
            }
            else
                marker.setOpacity(0);
        });
    }

    _getCellCoord(pnt, zoom) {
        // размер иконки + 10 пикселей бордер
        var size = 35;

        // здесь считаем координату ячейки, в которую попадает наша иконка точки трека.
        // множитель. Меняется в зависимости от масштаба
        var multipl = 2;
        if (zoom <= 15) multipl = 3;
        if (zoom <= 12) multipl = 4;

        // вычитаем 7.5, чтобы получить координаты верхнего левого угла
        return String(Math.round((pnt.x - 12.5) / size / multipl)) + ',' + String(Math.round((pnt.y - 12.5) / size / multipl));
    }

    clear(index) {
        this._makeRemoveLayerEvent(this.routeLayer);
        this._makeRemoveLayerEvent(this.markersLayer);
        this._makeRemoveLayerEvent(this.startEndMarkersLayer);
        this._makeRemoveLayerEvent(this.photosLayer);
        if (this.trailerWidthPolyline) {
            this._makeRemoveLayerEvent(this.trailerWidthPolyline);
            document.removeEventListener('zoomend', this._paintTrailerWidthPolyline);
        }
        if (this.playback)
            this.playback.destroy();
        this.deletePhotoMarkers();
        this.arrayOfPhotos = [];
        this._makeClosePhotosWindowEvent();

        this.closePhotosWindow();
        return this.reduceIndex(index);
    }

    reduceIndex(index) {
        index--;
        return index;
    }

    _makeFullRouteDistance(point) {
        // если точка по базовой станции (направление меньше 0), то ее пробег не будем учитывать
        if (point.dir >= 0)
            this.allDistance += point.dst;
        point.allDistance = this.allDistance / 1000;
    }

    _createLayer() {
        let multiOptions = {
            optionIdxFn: (latLng) => {
                return 0;
            },
            options: [
                { color: this.color },
            ]
        };

        return L.multiOptionsPolyline(this.coordsArray, {
            multiOptions: multiOptions,
            weight: this.config.routeLine.width,
            lineCap: 'round',
            interactive: false,
            opacity: 1,
            smoothFactor: 1,
            clickable: false,
        });
    }

    _fillCoordsArray(point) {
        this.coordsArray.push([point.lat, point.lon, 0]);
    }

    _makeAddLayerEvent(layer) {
        this.map.addLayer(layer);
    }

    _makeClosePhotosWindowEvent() {
        let event = new CustomEvent('ext:closePhotosWindow');
        document.dispatchEvent(event);
    }

    _makeRemoveLayerEvent(layer) {
        if (this.map.hasLayer(layer)) {
            try {
                this.map.removeLayer(layer);
            }
            catch (error) { }
        }
    }

    _getRouteColor(index) {
        if (typeof index === "string" ) {
            return index;
        }
        return this.routesColors[index % this.routesColors.length];
    }

    _createMarkersLayerClusterGroup(notClusteringZoom) {
        return new L.markerClusterGroup({
            disableClusteringAtZoom: notClusteringZoom,
            animate: false,
            maxClusterRadius: 30,
            spiderfyOnMaxZoom: false,
            clusterPane: 'routePane',
            iconCreateFunction: (cluster) => {
                return this._getIconForCluster(cluster);
            }
        });
    }

    _getIconForCluster(cluster) {
        var childs = cluster.getAllChildMarkers();
        cluster._latlng.lat = cluster._latlng.lat.toFixed(5);
        cluster._latlng.lng = cluster._latlng.lng.toFixed(5);
        let angle = childs[childs.length - 1].direction;
        var status = 5;
        var color = childs[childs.length - 1].color;
        return new L.DivIcon({
            html: '<div><img src="../../../Scripts/fort-map/dist/images/arrow-'
                + color + '.svg" style="width:25px; height:25px; -webkit-transform: rotate('
                + angle + 'deg); -moz-transform:rotate(' + angle + ' deg);"></div>',
            className: 'marker-cluster',
            iconAnchor: [12.5, 12.5],
            iconSize: [25, 25]
        });
    }

    makeFitBoundsEvent() {
        let bounds = this.routeLayer.getBounds();
    }

    _finalizeRoute() {
        if (this.pointsMakers.length > 1) {
            let startIcon = L.icon({
                iconUrl: '../../../Scripts/fort-map/dist/images/start.png',
                iconAnchor: [10, 10],
                iconSize: [20, 20],
            });

            let stopIcon = L.icon({
                iconUrl: '../../../Scripts/fort-map/dist/images/end.png',
                iconAnchor: [10, 10],
                iconSize: [20, 20],
                labelAnchor: [-50, 27]
            });

            let distMarker = new L.marker(
                this.pointsMakers[this.pointsMakers.length - 1].getLatLng(),
                { icon: stopIcon, opacity: 0.5,/*,  zIndexOffset: 3500*/ }
            );
            if (!this.map.isRadar) {
                distMarker.bindTooltip(
                    this._getDistanceString(this.allDistance),
                    {
                        className: `tooltip-${this.color}-border`,
                        permanent: true,
                        direction: 'right',
                        offset: new L.Point(15, -15)
                    }
                ).openTooltip();
            }
            let startMarker = new L.marker(
                this.pointsMakers[0].getLatLng(),
                { icon: startIcon, opacity: 0.5/*,  zIndexOffset: 3500*/ }
            );
            this.startEndMarkersLayer.addLayer(distMarker);
            this.startEndMarkersLayer.addLayer(startMarker);
            this._makeAddLayerEvent(this.startEndMarkersLayer);
        }
    }

    _getDistanceString(dst) {
        let dst_str = dst + ' ' + messages["meter"];
        if (dst > 1000) dst_str = (dst / 1000).toFixed(1) + ' ' + messages["kilometer"];
        return dst_str;
    }

    deletePhotoMarkers() {
        for (let marker of this.arrayOfPhotos) {
            marker.delete();
            marker = null;
        }
    }


    initPhotosWindow(photosMarkers) {
        if (photosMarkers && Ext)
            this.PhotosWindow = Ext.create('widget.photoswindow', { photosMarkers: photosMarkers });
    }

    closePhotosWindow() {
        if (this.PhotosWindow == null)
            return;
        this.PhotosWindow.close();
        this.PhotosWindow = null;
    }
}
